module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-content-nissan.452108d3.jpg";